module.exports = __webpack_public_path__ + "static/media/cod-remittance.0626078a.svg";